// removed by extract-text-webpack-plugin
module.exports = {"error":"tree-input-tooltip__error-1X7hv","success":"tree-input-tooltip__success-1YKzi"};


//////////////////
// WEBPACK FOOTER
// ./components/common/custom-order/rubrics/content/tree-input/tree-input-tooltip/tooltip.css
// module id = 825
// module chunks = 0